(function () {
  'use strict';
  if (window.SRCart) return;

  var EVENT = 'shopify:cart:lines-update';

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function cartRoutes() {
    var routes = (window.Theme && window.Theme.routes) || {};
    return {
      add: routes.cart_add_url || '/cart/add.js',
      update: (routes.cart_update_url || '/cart/update') + '.js',
      change: (routes.cart_change_url || '/cart/change') + '.js'
    };
  }

  function announce(action, lines, source) {
    var resolve, reject;
    var promise = new Promise(function (res, rej) { resolve = res; reject = rej; });

    var event = new CustomEvent(EVENT, { bubbles: true, composed: true });
    event.action = action;
    event.context = 'product';
    event.lines = lines || [];
    event.promise = promise;

    (source || document).dispatchEvent(event);
    return { resolve: resolve, reject: reject };
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function fetchCartAndSections() {
    var ids = cartSectionIds();
    var url = '/cart.js';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!ids.length) return { cart: cart, sections: {} };
        return fetch('/?sections=' + encodeURIComponent(ids.join(',')), {
          headers: { Accept: 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function (sections) { return { cart: cart, sections: sections }; })
          .catch(function () { return { cart: cart, sections: {} }; });
      });
  }

  function add(items, options) {
    options = options || {};
    var list = Array.isArray(items) ? items : [items];
    var lines = list.map(function (it) {
      return { merchandiseId: String(it.id), quantity: Number(it.quantity) || 1 };
    });

    var deferred = announce('add', lines, options.source);
    var sectionIds = cartSectionIds();

    var body = { items: list };
    if (sectionIds.length) body.sections = sectionIds.join(',');

    return fetch(cartRoutes().add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (result) {
        var didError = !result.ok || !!result.data.status;
        var sectionsFromAdd = !didError && result.data && result.data.sections;
        var next = sectionsFromAdd
          ? fetchCart().then(function (cart) { return { cart: cart, sections: sectionsFromAdd }; })
          : fetchCartAndSections();

        return next.then(function (state) {
          deferred.resolve({
            cart: state.cart,
            detail: {
              items: state.cart.items,
              source: 'sr-cart',
              sourceId: options.sourceId || 'sr-cart',
              sections: result.data.sections || state.sections,
              didError: didError
            }
          });
          if (didError) throw result.data;
          return result.data;
        });
      })
      .catch(function (error) {
        deferred.reject(error);
        throw error;
      });
  }

  function refresh(options) {
    options = options || {};
    var deferred = announce(options.action || 'change', [], options.source);
    return fetchCartAndSections()
      .then(function (state) {
        deferred.resolve({
          cart: state.cart,
          detail: {
            items: state.cart.items,
            source: 'sr-cart',
            sourceId: options.sourceId || 'sr-cart',
            sections: state.sections,
            didError: false
          }
        });
        return state.cart;
      })
      .catch(function (error) {
        deferred.reject(error);
        throw error;
      });
  }

  function openDrawer() {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!drawer) {
      var inner = document.querySelector('cart-drawer-component');
      drawer = inner && inner.closest('theme-drawer');
    }
    if (drawer && drawer.isOpen) return true;
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  }

  window.SRCart = {
    EVENT: EVENT,
    add: add,
    refresh: refresh,
    openDrawer: openDrawer,
    cartSectionIds: cartSectionIds
  };
})();
